import axios from "~/plugins/axios";

export default {
  approveAfdMessage(afdMessageId) {
    return axios.put(`/web_api/v1/sivi/afd_message/${afdMessageId}/approve`)
      .then((response) => response.data);
  },

  approveAfdMessages(afdMessageIds) {
    return axios.put("/web_api/v1/sivi/afd_message/approve", { afd_message_ids: afdMessageIds })
      .then((response) => response.data);
  },

  getByAfdMessageId(afdMessageId) {
    return axios.get(`/web_api/v1/sivi/by_afd_message/${afdMessageId}`)
      .then((response) => response.data);
  },

  paginateUnprocessedPackageMessages(
    filters = [],
    includes = [],
    order = "desc",
    orderBy = "datetime",
    page = 1,
    pageName = "packageMessagesPage",
    perPage = 15,
  ) {
    return axios.post("/web_api/v1/sivi/afd/paginate_unprocessed_package_messages", {
      filters,
      includes,
      order,
      order_by: orderBy,
      page,
      page_name: pageName,
      per_page: perPage,
    })
      .then((response) => response.data);
  },

  paginateUnprocessedPolicyMessages(
    filters = [],
    includes = [],
    order = "desc",
    orderBy = "datetime",
    page = 1,
    pageName = "policyMessagesPage",
    perPage = 15,
  ) {
    return axios.post("/web_api/v1/sivi/afd/paginate_unprocessed_policy_messages", {
      filters,
      includes,
      order,
      order_by: orderBy,
      page,
      page_name: pageName,
      per_page: perPage,
    })
      .then((response) => response.data);
  },

  rejectAfdMessage(afdMessageId) {
    return axios.put(`/web_api/v1/sivi/afd_message/${afdMessageId}/reject`)
      .then((response) => response.data);
  },

  rejectAfdMessages(afdMessageIds) {
    return axios.put("/web_api/v1/sivi/afd_message/reject", { afd_message_ids: afdMessageIds })
      .then((response) => response.data);
  },

  reapplyAfdMessage(afdMessageId) {
    return axios.put(`/web_api/v1/sivi/afd_message/${afdMessageId}/reapply`)
        .then((response) => response.data);
  }
};
